module.exports = __webpack_public_path__ + "img/briefing-table-icon.efb4df17.svg";